const cardTypes = [
  {
    name: "Mastercard",
    shortname: "mastercard",
    firstDigit: 2,
    cardNumberLength: 16,
    cvcLength: 3,
  },
  {
    name: "American Express",
    shortname: "amex",
    firstDigit: 3,
    cardNumberLength: 15,
    cvcLength: 4,
  },
  {
    name: "Visa",
    shortname: "visa",
    firstDigit: 4,
    cardNumberLength: 16,
    cvcLength: 3,
  },
  {
    name: "Mastercard",
    shortname: "mastercard",
    firstDigit: 5,
    cardNumberLength: 16,
    cvcLength: 3,
  },
  {
    name: "Discover",
    shortname: "discover",
    firstDigit: 6,
    cardNumberLength: 16,
    cvcLength: 3,
  },
];

export default cardTypes;
